<template>
  <header class="header">
    <div class="left">
      <h1 class="title">
        Skycard
      </h1>
      <h2 class="subtitle">
        <Trans>
          <template v-slot:en>
            Create and Share Your Sky Player Card
          </template>
          <template v-slot:jp>
            Sky Playerカードを作成して共有する
          </template>
        </Trans>
      </h2>
    </div>
    <div class="right">
      <LangSwitch></LangSwitch>
    </div>
  </header>
</template>

<script>
  import Trans from '../../components/text/Trans'
  import LangSwitch from './LangSwitch'

  export default {
    name: 'Header',
    components: { LangSwitch, Trans }
  }
</script>

<style scoped>
  .header {
    background: #eee;
    color: #333;
    padding: 24px;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #ccc;
  }

  .left {
    flex: 1 1 auto;
  }

  .right {
    flex: 0 0 auto;
    margin-left: 32px;
  }

  .title {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .subtitle {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 400;
  }
</style>
